import React, { useEffect, useState } from 'react'
import { message } from 'antd'

export default function useSubmit(submitFunction, suppressAlert = false) {
  const [submitted, setSubmitted] = useState({})
  const [submitting, setSubmitting] = useState(false)

  async function submit() {
    setSubmitting(true)
    try {
      const newObject = await submitFunction.apply(null, arguments)
      setSubmitted(newObject)
      suppressAlert || message.success('Success')
      setSubmitting(false)
      return newObject
    } catch (e) {
      console.error(e)
      suppressAlert || message.error(e.errorMessage || 'error')
    }
    setSubmitting(false)
  }

  return [submitting, submit]
}
